<i18n src="@/translations/FinLexiconEntryNotFound.json"></i18n>
<template>
  <div class="not-found pt-12">
    <h1>404</h1>
    <p v-html="$t('FinLexiconEntryNotFound.entry_not_found_text')"/>
  </div>
</template>

<script>

export default {
  name: 'FinLexiconEntryNotFound',
}
</script>

<style lang="scss" scoped>

.not-found {
  margin: auto;

  h1 {
    text-align: center;
    line-height: 200px;
    font-size: 50px;
    border: 2px solid $fin-color-cool-grey;
    color: $fin-color-cool-grey;
    border-radius: 100px;
    height: 200px;
    width: 200px;
    margin: 0 auto;
  }

  p {
    text-align: center;
    margin-top: 20px;
    color: $fin-color-cool-grey;
  }
}


</style>
